import React, { useEffect } from "react";
import {
  Text,
  Image,
  withSitecoreContext,
  RichText,
  isEditorActive,
  Link,
} from "@sitecore-jss/sitecore-jss-react";
import { TimerBannerProps } from "./types/TimerBanner.types";
import LazySection from "../../react-only-components/LazySection";
import "./index.scss";
import { anchorWithId } from "../../helpers/anchorWithId.helper";
import { LinkField } from "../../types/types";

const TimerBanner = (props: TimerBannerProps) => {
  const Timer = +(props?.fields?.timer?.value ?? '0') * 1000;

  useEffect(() => {
    if (props?.fields?.redirectlink?.value.href) {
      setTimeout(() => {
        if (typeof window !== 'undefined') {
          window.location.href = props?.fields?.redirectlink?.value.href ?? '';
        }
      }, Timer);
    }
  }, []);

  return (
    <LazySection offset={0}>
      {props.fields && (
        <div className="TimerBanner__Wrapper" id={props?.rendering?.uid}>
          <div className={"TimerBanner__root"}>
            <Image
              field={props?.fields?.backgroundimage}
              className={`TimerBanner__Image`}
            />
            <div className={`TimerBanner__TextWrapper`}>
              <RichText
                tag="div"
                field={props?.fields?.informationtext}
                className={`TimerBanner__TextWrapper--Text`}
              />
              {isEditorActive() ? (
                <Link
                  field={props?.fields?.redirectlink as LinkField}
                  className={`TimerBanner__TextWrapper--Link`}
                />
              ) : (
                <Link
                  field={{
                    value: props?.fields?.redirectlink?.value?.href,
                  }}
                  href={anchorWithId(
                    props?.fields?.redirectlink?.value?.href ?? '',
                    props?.fields?.redirectlink?.value?.anchor
                  )}
                  className={`TimerBanner__TextWrapper--Link`}
                >
                  <Text
                    field={{
                      value: props?.fields?.redirectlink?.value.text,
                    }}
                    tag="p"
                    className={`TimerBanner__TextWrapper--LinkText`}
                  />
                </Link>
              )}
            </div>
            <div className="TimerBanner__Footer">
              {props?.fields?.showcookielink?.value && (
                <div
                  className={`TimerBanner__ButtonWrapper ${
                    Object.keys(props?.fields?.footerlinks ?? []).length > 0
                      ? "FooterPadding"
                      : null
                  } `}
                >
                  <a
                    id="ot-sdk-btn"
                    className="ot-sdk-show-settings TimerBanner__ButtonWrapper--name"
                  >
                    <Text field={props?.fields?.cookiepolicytext} />
                  </a>
                </div>
              )}
              {props.fields?.footerlinks?.map((item, index: number) => (
                <div
                  className="TimerBanner__Footer--Links FooterLinks"
                  key={index}
                >
                  <Link
                    field={item?.fields?.link as LinkField}
                    className={`TimerBanner__ButtonWrapper--name`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </LazySection>
  );
};
export default withSitecoreContext()(TimerBanner);
